import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/gif/voice.gif")